  (() => {
    function initIsitglowShowroom() {
      document.querySelectorAll('[data-showroom-track]').forEach((track) => {
        if (track.dataset.showroomReady === 'true') return;
        const availableCards = Array.from(
          track.querySelectorAll('[data-showroom-card]')
        );
        if (availableCards.length < 2) return;
        track.dataset.showroomReady = 'true';
        /* Настройки на движението */
        const SLIDE_DURATION = 1400;
        const PAUSE_BETWEEN_SLIDES = 2600;
        const RESUME_AFTER_TOUCH = 2000;
        const details = track.closest('details');
        const drawer = track.closest('header-drawer')?.querySelector('details');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        let pointerHeld = false;
        let touchHeld = false;
        let keyboardFocus = false;
        let selectedCards = [];
        let originalCount = 0;
        let previousSelection = '';
        let currentIndex = 0;
        let autoplayTimer = null;
        let interactionTimer = null;
        let animationFrame = null;
        let userIsInteracting = false;
        let isAnimating = false;
        track.style.scrollBehavior = 'auto';
        function showroomIsOpen() {
          return track.isConnected && (!details || details.open) && (!drawer || drawer.open) && (!window.GlowNavigation || window.GlowNavigation.isOpen());
        }
        function cardPosition(index) {
          const firstCard = track.children[0];
          const targetCard = track.children[index];
          if (!firstCard || !targetCard) return 0;
          return targetCard.offsetLeft - firstCard.offsetLeft;
        }
        function easeInOutCubic(progress) {
          return progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        }
        function cancelAnimation() {
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          isAnimating = false;
          track.style.scrollSnapType = '';
        }
        function jumpTo(index) {
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = cardPosition(index);
          currentIndex = index;
          requestAnimationFrame(() => {
            track.style.scrollSnapType = '';
          });
        }
        /*
          Избира нови случайни чанти при всяко
          отваряне на менюто с бутона +.
        */
        function chooseNewShowroomCards() {
          const shuffledCards = [...availableCards];
          for (let i = shuffledCards.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(
              Math.random() * (i + 1)
            );
            [shuffledCards[i], shuffledCards[randomIndex]] = [
              shuffledCards[randomIndex],
              shuffledCards[i]
            ];
          }
          selectedCards = shuffledCards.slice(0, 8);
          let newSelection = selectedCards
            .map((card) => card.getAttribute('href'))
            .join('|');
          /*
            Не допускаме абсолютно същата селекция
            и подредба два пъти поред.
          */
          if (
            newSelection === previousSelection &&
            shuffledCards.length > 1
          ) {
            shuffledCards.push(shuffledCards.shift());
            selectedCards = shuffledCards.slice(0, 8);
            newSelection = selectedCards
              .map((card) => card.getAttribute('href'))
              .join('|');
          }
          previousSelection = newSelection;
          originalCount = selectedCards.length;
          selectedCards.forEach((card) => {
            card.removeAttribute('aria-hidden');
            card.removeAttribute('tabindex');
            card.removeAttribute('data-showroom-clone');
          });
          track.replaceChildren(...selectedCards);
          /*
            Добавяме идентично копие за
            незабележимо безкрайно движение.
          */
          selectedCards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.setAttribute('data-showroom-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            track.appendChild(clone);
          });
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = 0;
          currentIndex = 0;
          requestAnimationFrame(() => {
            track.style.scrollSnapType = '';
          });
        }
        function scheduleNext(
          delay = PAUSE_BETWEEN_SLIDES
        ) {
          clearTimeout(autoplayTimer);
          if (!showroomIsOpen() || !track.clientWidth || document.hidden || reducedMotion.matches || (keyboardFocus && track.contains(document.activeElement))) return;
          autoplayTimer = window.setTimeout(() => {
            if (
              userIsInteracting ||
              isAnimating ||
              document.hidden ||
              !showroomIsOpen()
            ) {
              scheduleNext(900);
              return;
            }
            moveToNextCard();
          }, delay);
        }
        function animateTo(targetIndex) {
          cancelAnimation();
          const startPosition = track.scrollLeft;
          const endPosition = cardPosition(targetIndex);
          const distance = endPosition - startPosition;
          const startTime = performance.now();
          isAnimating = true;
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          function animationStep(currentTime) {
            if (!showroomIsOpen() || document.hidden || reducedMotion.matches) { cancelAnimation(); return; }
            const elapsed = currentTime - startTime;
            const progress = Math.min(
              elapsed / SLIDE_DURATION,
              1
            );
            const easedProgress =
              easeInOutCubic(progress);
            track.scrollLeft =
              startPosition + distance * easedProgress;
            if (progress < 1) {
              animationFrame =
                requestAnimationFrame(animationStep);
              return;
            }
            animationFrame = null;
            isAnimating = false;
            /*
              При достигане на първата клонирана чанта
              преминаваме към идентичния оригинал.
              Няма видимо връщане към началото.
            */
            if (targetIndex >= originalCount) {
              track.scrollLeft = cardPosition(
                targetIndex - originalCount
              );
              currentIndex =
                targetIndex - originalCount;
            } else {
              currentIndex = targetIndex;
            }
            track.style.scrollSnapType = '';
            scheduleNext();
          }
          animationFrame =
            requestAnimationFrame(animationStep);
        }
        function moveToNextCard() {
          if (originalCount < 2) return;
          animateTo(currentIndex + 1);
        }
        function findNearestCardIndex() {
          let nearestIndex = 0;
          let nearestDistance = Infinity;
          Array.from(track.children).forEach(
            (card, index) => {
              const distance = Math.abs(
                track.scrollLeft - cardPosition(index)
              );
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            }
          );
          return nearestIndex;
        }
        function startInteraction() {
          userIsInteracting = true;
          clearTimeout(autoplayTimer);
          clearTimeout(interactionTimer);
          cancelAnimation();
        }
        function finishInteraction() {
          if (!userIsInteracting || pointerHeld) return;
          clearTimeout(interactionTimer);
          const nearestIndex = findNearestCardIndex();
          const matchingOriginal =
            nearestIndex % originalCount;
          /*
            Ако човек е стигнал до копираните чанти,
            го преместваме върху съответния оригинал
            без видима промяна.
          */
          if (nearestIndex >= originalCount) {
            jumpTo(matchingOriginal);
          } else {
            currentIndex = nearestIndex;
            track.style.scrollSnapType = '';
          }
          userIsInteracting = false;
          scheduleNext(RESUME_AFTER_TOUCH);
        }
        track.addEventListener(
          'pointerdown',
          () => { keyboardFocus = false; pointerHeld = true; startInteraction(); },
          { passive: true }
        );
        window.addEventListener(
          'pointerup',
          () => {
            if (!pointerHeld || touchHeld) return; pointerHeld = false;
            clearTimeout(interactionTimer);
            interactionTimer = window.setTimeout(
              finishInteraction,
              450
            );
          },
          { passive: true }
        );
        window.addEventListener(
          'pointercancel',
          () => {
            if (!pointerHeld || touchHeld) return; pointerHeld = false;
            clearTimeout(interactionTimer);
            interactionTimer = window.setTimeout(
              finishInteraction,
              450
            );
          },
          { passive: true }
        );
        track.addEventListener(
          'scroll',
          () => {
            if (!userIsInteracting || pointerHeld) return;
            clearTimeout(interactionTimer);
            interactionTimer = window.setTimeout(
              finishInteraction,
              220
            );
          },
          { passive: true }
        );
        track.addEventListener('wheel', () => {
          startInteraction();
          interactionTimer = setTimeout(finishInteraction, 300);
        }, { passive:true });
        track.addEventListener('focusin', () => { if(keyboardFocus){clearTimeout(autoplayTimer);cancelAnimation();} });
        track.addEventListener('focusout', () => setTimeout(scheduleNext, 0));
        document.addEventListener('keydown', event => { if(event.key==='Tab'||event.key.startsWith('Arrow'))keyboardFocus=true; });
        track.addEventListener('touchstart', () => { keyboardFocus=false;touchHeld=true;pointerHeld=true;startInteraction(); }, {passive:true});
        const finishTouch = () => {
          if(!touchHeld)return;
          touchHeld=false;pointerHeld=false;clearTimeout(interactionTimer);
          interactionTimer=window.setTimeout(finishInteraction,450);
        };
        window.addEventListener('touchend',finishTouch,{passive:true});
        window.addEventListener('touchcancel',finishTouch,{passive:true});
        document.addEventListener('glow:overlay-change',() => {
          clearTimeout(autoplayTimer);cancelAnimation();
          if(showroomIsOpen()&&!pointerHeld)scheduleNext();
        });
        if(typeof ResizeObserver!=='undefined')new ResizeObserver(() => {
          if(!isAnimating&&!userIsInteracting&&showroomIsOpen())scheduleNext();
        }).observe(track);
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); startInteraction();
          const target = Math.max(0, Math.min(track.children.length - 1, findNearestCardIndex() + (event.key === 'ArrowLeft' ? -1 : 1)));
          track.scrollTo({left:cardPosition(target), behavior:reducedMotion.matches ? 'instant' : 'smooth'});
          interactionTimer = setTimeout(finishInteraction, 300);
        });
        if (drawer && drawer !== details) drawer.addEventListener('toggle', () => {
          clearTimeout(autoplayTimer); cancelAnimation();
          if (showroomIsOpen()) { currentIndex = findNearestCardIndex() % originalCount; scheduleNext(); }
        });
        document.addEventListener('visibilitychange', () => {
          clearTimeout(autoplayTimer); cancelAnimation();
          if (!document.hidden && showroomIsOpen()) scheduleNext();
        });
        reducedMotion.addEventListener('change', () => { clearTimeout(autoplayTimer); cancelAnimation(); scheduleNext(); });
        /*
          При всяко ново отваряне с +
          избираме различни случайни чанти.
        */
        if (details) {
          details.addEventListener('toggle', () => {
            clearTimeout(autoplayTimer);
            clearTimeout(interactionTimer);
            cancelAnimation();
            userIsInteracting = false;
            if (details.open) {
              chooseNewShowroomCards();
              scheduleNext();
            }
          });
        }
        /*
          Подготвяме първата селекция,
          без да стартираме движение при затворено меню.
        */
        chooseNewShowroomCards();
        if (showroomIsOpen()) {
          scheduleNext();
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initIsitglowShowroom
      );
    } else {
      initIsitglowShowroom();
    }
    document.addEventListener(
      'shopify:section:load',
      initIsitglowShowroom
    );
  })();

